module.exports = __webpack_public_path__ + "img/19.311c3b4b.jpg";